import { render, staticRenderFns } from "./DrugsHeader.vue?vue&type=template&id=a24a4d66"
import script from "./DrugsHeader.vue?vue&type=script&lang=js"
export * from "./DrugsHeader.vue?vue&type=script&lang=js"
import style0 from "./DrugsHeader.vue?vue&type=style&index=0&id=a24a4d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports